




































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  RiskProfileQuestionDto,
  UIControlType
} from "@/api/ClientPortalApiClient";
import { RiskProfileStore } from "@/store";
import QuestionResponse from "./QuestionResponse";

@Component<RiskProfileQuestion>({
  props: {
    question: {
      type: Object as () => RiskProfileQuestionDto
    },
    submitted: {
      type: Boolean
    },
    number: {
      type: Number
    }
  },
  // Watch the values of the selected items so we can update our state in the Vuex store
  watch: {
    selectedCheckboxes: function() {
      this.updateState();
    },
    selectedSingle: function() {
      this.updateState();
    },
    selectedValue: function() {
      this.updateState();
    }
  }
})
export default class RiskProfileQuestion extends Vue {
  question?: RiskProfileQuestionDto;
  number?: number;
  submitted?: boolean;

  selectedCheckboxes: number[] = [];
  selectedSingle: number = 0;
  selectedValue: string = "0";

  created() {
    const responses = RiskProfileStore.Responses;
    if (responses && this.question) {
      const state = responses.find(
        x => x.questionId == (this.question ? this.question.id : 0)
      );
      if (state) {
        if (this.question.multipleAnswersAllowed) {
          this.selectedCheckboxes = state.selectedValues;
        } else if (this.isNumeric) {
          this.selectedValue =
            this.question.answers!.find(x => x.id === state.selectedValues[0])!
              .text || "18";
        } else {
          this.selectedSingle = state.selectedValues[0];
        }
        this.updateState();
      }
    }
  }

  get selectedAnswers(): number[] {
    let selected: number[] = [];
    selected = selected.concat(this.selectedCheckboxes);

    if (this.selectedSingle > 0) {
      selected.push(this.selectedSingle);
    }

    if (this.selectedValue !== "0") {
      const answer = this.question!.answers!.find(
        x => x.text == this.selectedValue
      );
      if (answer) {
        selected.push(answer.id);
      }
    }

    return selected;
  }

  get isValid(): boolean {
    return !this.question!.answerRequired || this.selectedAnswers.length > 0;
  }

  get isRadioButton(): boolean {
    return this.question
      ? this.question.uiControlType == UIControlType.RadioButtons
      : false;
  }

  get isDropDown(): boolean {
    return this.question
      ? this.question.uiControlType == UIControlType.DropDownList
      : false;
  }

  get isNumeric(): boolean {
    return this.question
      ? this.question.uiControlType == UIControlType.Numeric
      : false;
  }

  get validationMessage(): string {
    let message: string | undefined;
    const qId = this.question ? this.question.id : 0;
    if (qId > 0) {
      const val = RiskProfileStore.ValidationMessages.find(
        x => x.questionId === qId
      );
      message = val ? val.message : "";
    }

    return message || "";
  }

  updateState() {
    if (this.question) {
      const newResponse: QuestionResponse = {
        requestId: RiskProfileStore.SelectedRequest.id,
        questionId: this.question.id,
        selectedValues: this.selectedAnswers
      };

      RiskProfileStore.SetResponse(newResponse);
    }
  }
}
